<template>
  <div class="share_note">
    <div
      class="share_note__close global_pointer"
      @click="$emit('shareClose')"
    >
      <img :src="require('@/assets/imgs/room/close.png')">
    </div>
    <!-- <img :src="require('@/assets/imgs/room/share_note.png')"> -->
    <div class="share_note_title">
      Give $75, Get $75
    </div>
    <!-- <div class="share_note__header">
      Give {{ newGift.en.currency + newGift.en.beInviter.reduction }},
      Get {{ newGift.en.currency + newGift.en.inviter.reduction }}
    </div> -->
    <div class="share_note__body">
      <van-swipe
        class="share_note__swipe"
        indicator-color="rgba(0, 0, 0, 1)"
        :loop="false"
      >
        <van-swipe-item>
          <div class="share_note__swipe_item_1_1 share_note__swipe_item_info">
            <img :src="require('@/assets/imgs/room/heart.png')">
            <span>Invite your friends to download the ShopShops app.</span>
          </div>
          <div class="share_note__swipe_item_1_2 share_note__swipe_item_info">
            <img :src="require('@/assets/imgs/room/shopping_cart.png')">
            <!-- <span>Your friends get {{ newGift.en.currency + newGift.en.beInviter.reduction }} off their first purchase.</span> -->
            <span>Your friends get {{ newGift.en.currency + newGift.en.beInviter.reduction }} to shop*</span>
          </div>
          <div class="share_note__swipe_item_1_3 share_note__swipe_item_info">
            <img :src="require('@/assets/imgs/room/favorites.png')">
            <span>
              You get  {{ newGift.en.currency + newGift.en.inviter.reduction }}  off for every friend that makes a {{ newGift.en.currency + newGift.en.beInviter.spend }} purchase.
            </span>
          </div>
          <div class="share_note__swipe_item_1_3 share_note__swipe_item_info">
            <!-- <img :src="require('@/assets/imgs/room/favorites.png')" style="visibility: hidden;"> -->
            <span>
              *Coupon restrictions apply
            </span>
          </div>
          
          <div class="share_note__swipe_item_1_4">{{code}}</div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="share_note__swipe_item_2_1">
            <img :src="require('@/assets/imgs/room/information.png')">
          </div>
          <div class="share_note__swipe_item_2_2">
            <p>Friends must download the app and use your referral code to get $75. The $75 is split into two coupons, one $25 off of $250+ that is given automatically, and another $50 off of $350+ after your friend RSVPs to a livestream. </p>
            <p>For every friend that makes a first time purchase of $200 or more, you will get $75 to use on a purchase of $300+.</p>
            <!-- Friends must download the app and use your referral code to get {{ newGift.en.currency + newGift.en.beInviter.reduction }} to use on a purchase of {{ newGift.en.currency + newGift.en.beInviter.full }} or more (limited to new customers only). For every friend that makes a first time purchase of {{ newGift.en.currency + newGift.en.beInviter.spend }} or more, you will also get {{ newGift.en.currency + newGift.en.inviter.reduction }} to use on a purchase of {{ newGift.en.currency + newGift.en.inviter.full }} or more. -->
          </div>
        </van-swipe-item>
      </van-swipe>
      <div class="share_note__footer">
        <span>Tap to Share</span>
        <img :src="require('@/assets/imgs/room/arrow_down.png')" />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Swipe, SwipeItem } from "vant";
import { newGift } from "@/common/constData.js";
Vue.use(Swipe);
Vue.use(SwipeItem);
export default {
  props: {
    code: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      newGift,
    };
  },
};
</script>

<style lang="less" scoped>
  /deep/.van-swipe__indicators{
    bottom: 0;
  }
  .share_note_title{
      width: 268px;
      height: 80px;
      line-height: 80px;
      background-color: #f5d3cd;
      border-radius: 15px;
      font-size: 30px;
      font-weight: bold;
      font-family: 'TradeGothicLT-Bold';
      letter-spacing: -1px;
      color: #000;
  }
  .share_note {
    width: 268px;
    height: 404px;
    display: flex;
    flex-direction: column;
    position: relative;
    &__close {
      position: absolute;
      right: 5px;
      top: 5px;
      > img {
        width: 26px;
      }
    }
    // &__header {
    //   width: 100%;
    //   height: 80px;
    //   line-height: 80px;
    //   background: rgb(240, 212, 206);
    //   color: #000000;
    //   font-size: 30px;
    //   font-family: "TradeGothicLT-Bold";
    //   border-radius: 14px;
    //   font-weight: 700;
    // }
    > img {
      width: 100%;
    }
    &__body {
      flex: 1;
      background-color: rgba(255, 255, 255, 1);
      width: 100%;
      height: 100%;
      border-radius: 11px;
    }
    &__swipe {
      .van-swipe-item {
        color: rgba(0, 0, 0, 1);
        height: 292px;
      }
      &_item_info {
        width: 229.99px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        > img {
          width: 22px;
        }
        > span {
          width: 190px;
          height: 36px;
          font-size: 14px;
          color: #000000;
          line-height: 18px;
          text-align: left;
          font-family: "TradeGothicLT";
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      &_item {
        &_1_1 {
          margin: 21px auto auto auto;
        }
        &_1_2,
        &_1_3 {
          margin: 19px auto auto auto;
        }
        &_1_4 {
          margin: 7.5px auto auto auto;
          background: #e8e8e8;
          border-radius: 6px;
          border: 0.5px solid #808080;
          width: 246px;
          height: 44px;
          line-height: 44px;
          font-size: 20px;
          color: #000000;
          letter-spacing: 5px;
          text-align: center;
          font-family: "TradeGothicLT";
        }
        &_2_1 {
          width: 23px;
          height: 23px;
          text-align: center;
          margin: 20px auto auto auto;
          > img {
            width: 100%;
          }
        }
        &_2_2 {
          width: 227px;
          margin: 5px auto auto auto;
          font-size: 14px;
          color: #000000;
          line-height: 22px;
          text-align: left;
        }
      }
    }
    &__footer {
      width: 100%;
      height: 44px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      color: #000000;
      line-height: 15px;
      font-family: "TradeGothicLT";
      > img {
        width: 19px;
        margin-left: 2px;
      }
    }
  }
</style>
<style scoped>
  .share_note >>> .van-swipe__indicator {
    background-color: rgba(151, 151, 151, 1);
  }
</style>